<header [id]="headingId" (click)="getHeaderLink()" class="sub-menu-v2--header">
    <label>{{ heading }}</label>
    <i *ngIf="showChevron" class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
</header>

<ul *ngIf="options?.length" class="sub-menu-v2--dropdown">
    <ng-container *ngFor="let item of options; let $index = index; trackBy: trackByFn">
        <li
            *ngIf="item.Status !== 'Bin'"
            [ngClass]="{ 'dropdown-item-zero': item.Quantity < 1, 'dropdown-item-inset': item.Status !== 'All' }">
            <input
                legacy-css
                type="checkbox"
                name="status[]"
                [checked]="selections?.indexOf(convertKey(item)) > -1"
                value="{{ item.Value || item.Status || item.status }}"
                (click)="toggleSelection(item)"
                class="sub-menu-v2-cb"
                id="{{ heading + '-cb' + $index }}" />

            <label for="{{ heading + '-cb' + $index }}">
                {{ item.Status || item.status }}

                <div class="pull-right">
                    <span class="badge" *ngIf="item.badgeCount"> {{ item.badgeCount }} </span>
                    <span *ngIf="defaultRoute === '/customers/connections'" class="badge badge-stats">{{ item.count }}</span>
                    <span class="badge badge-stats">{{ item.Quantity }}</span>
                </div>
            </label>
        </li>
    </ng-container>
</ul>
